export const searchNotFoundData = {
  title: 'common:emptySearchTitle',
  description: 'common:emptySearchDescription',
  icon: '/assets/error-icon.svg',
};
